<template>
  <div class="container">
    <p>Admin Board</p>
    <h3>{{ content }}</h3>
  </div>
</template>

<script>
import UserService from "../../services/user.service.js";

export default {
  name: "Admin",
  data() {
    return {
      content: "",
    };
  },
  mounted() {
    UserService.getUserContent().then(
      (response) => {
        this.content = response.data;
      },
      (error) => {
        this.content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  },
};
</script>
